/**
 * Browser/project idempotency key. Prefer crypto.randomUUID; otherwise
 * `${Date.now()}_${Math.random().toString(36).substring(2, 15)}`.
 *
 * @returns {string}
 */
export function generateIdempotencyKey() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `${Date.now()}_${Math.random().toString(36).substring(2, 15)}`
}
